import { Dictionary } from "./Dictionary";

export const toDictionary = <TInput, TValue,>(items: TInput[], key: (item: TInput) => string, value: (item: TInput) => TValue): Dictionary<TValue> => {
    const result: Dictionary<TValue> = {};

    for (const item of items) {
        result[key(item)] = value(item);
    }

    return result;
};